import { MarketingAgentDecisionType } from "@redotech/redo-marketing-common/agent-decision/marketing-agent-decision-definition";
import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

// Trigger schemas
const eventTriggerOutputSchema = z.object({
  type: z.literal("event"),
  eventId: z.string().optional(),
  orderTrackingEvent: z
    .object({
      orderId: z.string(),
      trackingCode: z.string().nullable().optional(),
      fulfillmentId: z.string().nullable().optional(),
    })
    .optional(),
  triggerKey: z.string().optional(),
});

const decisionTriggerOutputSchema = z.object({
  type: z.literal("decision"),
  decisionId: z.string(),
  decisionType: createEnum(MarketingAgentDecisionType, {
    enumName: "MarketingAgentDecisionType",
  }),
});

const triggerOutputSchema = z.discriminatedUnion("type", [
  eventTriggerOutputSchema,
  decisionTriggerOutputSchema,
]);

// Thread data schema (simplified for drawer display)
const threadDataSchema = z.object({
  _id: z.string(),
  agentName: z.string(),
  prompt: z.string(),
  messages: z.array(MessageSchema),
  state: z.json(),
  output: z.json().optional(),
  iterationCount: z.number(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getMarketingAgentDecisionDetails = {
  name: "getMarketingAgentDecisionDetails" as const,
  input: z.object({ decisionId: z.string() }),
  output: z
    .object({
      _id: z.string(),
      teamId: z.string(),
      teamName: z.string(),
      customerId: z.string(),
      customerEmail: z.string().optional(),
      type: createEnum(MarketingAgentDecisionType, {
        enumName: "MarketingAgentDecisionType",
      }),
      trigger: triggerOutputSchema,
      data: z.json(), // Decision-specific data (sentinel/vanguard/writer)
      triggeredAt: z.date(),
      finishedAt: z.date(),
      createdAt: z.date(),
      thread: threadDataSchema.optional(),
    })
    .nullish(),
};
